export const environment = {
    appName: 'Clinng Voucher CERT',
    production: false,
    apiConfig: {
      cashProcessorUrl: 'https://cert.experience.cash.monnet.io/api/v1/ms-experience-monnet-cash/payment/voucher',
      payinCheckoutBackendUrl: 'https://cert.payin.experience.monnet.io/api/v1/payin-checkout-experience/',
      voucherPayinExperienceUrl: 'TODO: Add URL here',
      websocket: "wss://cert.payin.experience.monnet.io/api/v1/payin-checkout-experience/ws",
      modoSdk: 'https://ecommerce-modal.preprod.modo.com.ar/bundle.js',
      payinMetricExperienceUrl: 'https://cert.payin.experience.monnet.io/ms-payin-metric-experience',
      virtualAccountsApiUrl: 'https://cert.virtual-accounts.monnet.io/account-voucher-api/v1',
      virtualAccountsWs: 'https://cert.virtual-accounts.monnet.io/account-voucher-api/ws',
    }
  };